/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { Input, Select, Form } from "antd";
import { useSelector } from "react-redux";
import styles from "./edit-or-view-cell.module.less";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import DropdownIcon from "Components/DropdownIcon/DropdownIcon";
import { useMemo } from "react";
import { DebounceSearchSelect } from "Components/Search";
import { resourcesAPI } from "../../../api/api";

const { TextArea } = Input;

const EditOrViewCell = ({
  exhibitionId,
  standId,
  editExhibitionId,
  editStandId,
  editingType,
  view,
  defaultValue,
  isStandEditable,
  onCountryChange,
  formItemName,
  OnlyLatinLettersTextInput,
  form,
  isDisabled,
  placeholder,
  rules,
  fieldKey
}) => {
  const { isEditMode } = useSelector((state) => state.exhibitions);
  const { isAdmin } = useSelector((state) => state.auth);
  const [openState, setOpenState] = useState(false);
  const [selectorCities, setSelectorCities] = useState([]);
  const isExhibitionEditable = isEditMode && exhibitionId === editExhibitionId;
  const isStandCurrentlyEditable = isEditMode && standId === editStandId;
  const countryIds = form.getFieldValue(["exhibition", "countryId"]);
  const { countries, cities } = useSelector((state) => state.resources);
  const { t } = useTranslation(["Countries", "FS8-changeCompanyProfile"]);
  const { lang } = useSelector((state) => state.auth);

  const renderSelectOptions =
    countries.length &&
    countries.map((country) => (
      <Select.Option key={country.id} value={country.id}>
        {t(country.name, { ns: "Countries" })}
      </Select.Option>
    ));
  /* const renderCitySelectOptions =
    cities.length &&
    cities.map((cities) => (
      <Select.Option key={cities.id} value={cities.id}>
        {cities.localizedName[lang]}
      </Select.Option>
    )); */

  const citiesOptions = useMemo(
    () =>
      selectorCities.map(({ id, localizedName }) => ({
        label: localizedName[lang],
        value: id
      })),
    [selectorCities, lang]
  );

  const renderEditingComponent = useMemo(() => {
    switch (editingType) {
      case "text":
        return (
          <TextArea
            className={styles.textInput}
            defaultValue={defaultValue}
            disabled={isDisabled}
            placeholder={placeholder}
            autoSize={{ minRows: 4, maxRows: 6 }}
            onChange={(e) =>
              !isAdmin
                ? OnlyLatinLettersTextInput(
                    e.target.value,
                    formItemName,
                    form,
                    true,
                    null,
                    null,
                    true
                  )
                : e.target.value
            }
          />
        );
      default:
        return null;
    }
  }, [isDisabled]);
  const handleCitiesSearch = async (name, customCountry) => {
    const countryIds = form.getFieldValue(["exhibition", "countryId"]);
    if (!countryIds && !customCountry) return;
    const response = await resourcesAPI.getCities(name, customCountry || countryIds);
    return { data: response.data?.cities };
  };

  const getDefaultCities = async () => {
    const countryIds = form.getFieldValue(["exhibition", "countryId"]);
    const response = await handleCitiesSearch("", countryIds || defaultValue.countryId);
    if (response?.data) setSelectorCities(response?.data);
  };

  useEffect(() => {
    if (editingType === "COUNTRY_SELECT" || editingType === "CITY_SELECT") getDefaultCities();
  }, [countryIds]);

  return (
    <Form.Item
      name={formItemName}
      rules={[
        {
          required: true,
          message: ""
        },
        ...(rules || [])
      ]}
    >
      {(isExhibitionEditable || (isStandCurrentlyEditable && isStandEditable)) && isEditMode ? (
        editingType === "COUNTRY_SELECT" ? (
          <Select
            className={styles.countrySelect}
            defaultValue={defaultValue}
            style={{ width: "100%" }}
            disabled={isDisabled}
            onDropdownVisibleChange={(state) => {
              setOpenState(state);
            }}
            dropdownStyle={{width: "100%"}}
            onChange={() => onCountryChange()}
            open={openState}
            size="small"
            suffixIcon={
              <DropdownIcon
                onClick={() => {
                  setOpenState((prevState) => !prevState);
                }}
              />
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) => {
              return optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase());
            }}
          >
            {renderSelectOptions}
          </Select>
        ) : editingType === "CITY_SELECT" ? (
          <DebounceSearchSelect
            className={styles.countrySelect}
            search={handleCitiesSearch}
            size="small"
            style={{ width: "100%" }}
            store={setSelectorCities}
            disabled={isDisabled}
            options={citiesOptions}
            defaultValue={form.getFieldValue("cityId")}
          />
        ) : (
          renderEditingComponent
        )
      ) : (
        view
      )}
    </Form.Item>
  );
};

export default React.memo(EditOrViewCell);
